const { useEffect, useState } = require("react")
const { getIcon } = require("../../../../utils/store/browserStorage/icon")

/**
 * Icon Custom Hook
 */
module.exports = function useIcon(uid, timestamp) {

  const [icon, setIcon] = useState(null);
  const [refresh, setRefresh] = useState(null)

  useEffect(() => {
    //console.log("getIcon of uid ", uid, timestamp);
    let stopPromise = false;
    let timeout = null
    if (uid) {
      getIcon(uid, timestamp).then(img => {
        //console.log("img", img, stopPromise);
        if (!stopPromise) {
          setIcon(img);
        }
      }).catch(err => {
        console.error(err);
        if (!stopPromise) timeout = setTimeout(() => {
          setRefresh(Date.now())
        }, 1000)
      })
    }
    return () => {
      stopPromise = true;
      clearTimeout(timeout)
    }
  }, [uid, timestamp, refresh]);

  return icon;
}